module.exports = __webpack_public_path__ + "static/fonts/Mont-BlackItalic.e49be7a.ttf";